import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams  } from 'react-router-dom';
import apiService from '../../../Auth/apiService';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import MenuCaracterizacion from '../Componentes/MenuCaracterizacion';
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import CargandoSpinner from '../../Utils/CargandoSpinner';
import { useAuth } from '../../../Auth/AuthContext';

export default function PersonaEditDocumento() {
    const { token, user } = useAuth();
    const hasRun = useRef(false);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const { id } = useParams();
    const { idPersona } = useParams();
    const { idCabezaFamilia } = useParams();
    const [tipoIdentificaciones, setTipoIdentificaciones] = useState([]);
    const [persona, setPersona] = useState({
        id: "0",
        per_idpersona: "",
        nombre: "",
        per_tipoid: "",
        per_tipoidnombre: "",
        idCabezaFamilia: ""
    });
    const [Cargando, setCargando] = useState(false);
    const {register, handleSubmit, control, setValue, reset, formState: { errors }} = useForm();
    useEffect(() => {
        if (!hasRun.current) {
            const fetchData = async () => {
                const url = '/caracterizacion/crearformularioactualizardoc';
                const obj = {id: id, idCabezaFamilia: idCabezaFamilia}
                try {
                    setCargando(true);
                    const response = await apiService.post(url, obj, token);
                    const result = await response.data;
                    if(result.persona){
                        setPersona(result.persona);
                        reset((prevValues) => ({
                            ...prevValues,
                            Id: result.persona.id,
                            perIdpersonaAnterior: result.persona.per_idpersona,
                            perIdpersona: result.persona.per_idpersona,
                            perTipoid: result.persona.per_tipoid,
                            user: String(user),
                        }));
                    }
                    setTipoIdentificaciones(result.tipoidentificacion);
                } catch (error) {
                    handleError(error, navigate, Mensaje);
                    console.error('Error fetching data:', error);
                } finally {
                  setCargando(false);
                }
            };
    
            fetchData();
            hasRun.current = true;
        }
    }, [id, idPersona, token, setValue, user, reset, idCabezaFamilia, navigate]);
    
    const onSubmit = async (data) => {
        setCargando(true);
        let url;

        if(id!=="0"){
            url = '/caracterizacion/actualizarpersonadocumento';
        }
        
        await apiService.post(url, data, token)
        .then((response) => {
            if(response.status === 200){
                Mensaje('Guardar documento persona', 'Documento actualizado exitosamente');
            } else {
                Mensaje('Documento', 'Error al actualizar persona');
            }
        }).catch((error) => {
            if(error.status === 422){
                const respuestalista = error.response.data.errors.map(error => `<li>${error.field}-${error.message}</li>`).join('');
                Mensaje('Guardar persona fallo', `<ul>${respuestalista}</ul>`);
            } else if(error.status === 404){
                Mensaje('Guardar persona fallo', 'Persona no encontrada');
            } else if(error.status === 409){
                Mensaje('Guardar persona fallo', error.response.data);
            }else {
                Mensaje('Guardar persona fallo', `Error al guardar persona ${error}`);
            }
        })
        .finally(() => {
            setCargando(false);
        });
      };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            html: text,
        });
    };
    return(
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Formulario persona"
                idCabezaFamilia={idCabezaFamilia}
                url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`}
                nombreurl="Grupo familiar"
                nombreform="persona"
                />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {(idCabezaFamilia !== "0") && 
                        <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}/>
                    }
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-info">
                        <div className="card-header">
                            <h3 className="card-title">Persona</h3>
                        </div>
                        {/* /.card-header */}
                        {/* form start */}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                <div className="card">
                                    <div className="card-header">
                                    <h5 className="card-title m-0">Identificaci&oacute;n - Actualizar documento {idCabezaFamilia === "0" && '- Jefe de Hogar'}</h5>
                                    </div>
                                    <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">{persona.nombre}</div>
                                        <div className="col-md-4">Documento actual: {persona.per_idpersona}</div>
                                        <div className="col-md-4">Cabeza familia: {persona.idCabezaFamilia}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group" >

                                                <label htmlFor="perTipoid">Tipo identificaci&oacute;n</label>
                                                <select id="perTipoid" className='form-control' 
                                                    {...register('perTipoid', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tipoIdentificaciones.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.tipTipoidentificacion}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perTipoid && <p style={{color: 'red'}}>Seleccionar tipo identificaci&oacute;n</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perIdpersona">Identificaci&oacute;n</label>
                                                <input id="perIdpersona" className="form-control" 
                                                    {...register('perIdpersona', { required: true })}
                                                    placeholder="Identificacion"
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                        setValue('perIdpersona', value); // Update the value in the form
                                                      }}/>
                                                {errors.perIdpersona && <p style={{color: 'red'}}>Digite el documento</p>}
                                                <input hidden id="user" className="form-control" 
                                                    {...register('user', { required: true })}/>
                                                <input hidden id="Id" className="form-control" 
                                                    {...register('Id', { required: true })}/>
                                                <input hidden id="perIdpersonaAnterior" className="form-control" 
                                                    {...register('perIdpersonaAnterior', { required: true })}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                            <button type="submit" className="btn btn-info">Actualizar</button>
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </div>
    )


}